'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { getSignupUrl } from '../utils/urls';
export default (({
  isFbSignin,
  signupParams,
  loginRedirectUrlQueryParam
}) => {
  const signupUrl = getSignupUrl(signupParams, isFbSignin, loginRedirectUrlQueryParam);
  return /*#__PURE__*/_jsxs("div", {
    className: "signup-link",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.signupLink.text"
    }), /*#__PURE__*/_jsx(UILink, {
      href: signupUrl,
      className: "m-left-1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "login.signupLink.cta"
      })
    })]
  });
});